import request from 'utils/request'

/**
 * 获取批量申请列表
 * @param {*} data
 */
export const getLimitBatchList = data =>
  request().post('periodBatch/upload/page', data)
  
/**
 * 获取审批人列表
 */
export const getLimitApprovePersons = id =>
request().get(`periodBatch/apply/listApprovePerson/${id}`)

/**
 * 下载项额度批量申请模板
 */
export const limitDownload = () =>
  request().get('periodBatch/download', { responseType: 'blob' })

  /**
 * 上传批量申请文件 获取上传code的相关信息
 * @param {*} data
 */
export const uploadCodeFile = data =>
request().post('periodBatch/upload', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  responseType: 'blob',
})

/**
 * 限额延期批量申请验证
 */
export const check = id => request().get(`periodBatch/upload/check/${id}`)

/**
 * 提交批量申请审批
 * @param {*} data
 */
export const batchLimit = data => request(false).post('periodBatch/batch/apply', data)

/**
 *
 *获取业务模式
 *
 */
export const getModelList = data => request().post('business/region/list', data)

export const exportLists = data =>
  request().post('periodBatch/upload/export', data, {
    responseType: 'arraybuffer',
  })

// 获取业务模式冻结列表
export const getFreezeModelList = () =>
  request().get('business/jsonList/getFreezeModelList')

/**
 * 上传批量申请文件
 * @param {*} data
 */
export const uploadLimitFile = data =>
  request().post('periodBatch/periodUpload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  export const uploadPeriodCheck = data =>
  request().post('periodBatch/termList/check', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// 获取业务类型冻结列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

/**
 * 下载批量文件
 * @param {*} id
 */
export const downloadLimitBatchFile = id =>
  request().get(`periodBatch/download/${id}`, { responseType: 'blob' })

  /**
 * 获取jsonList类型的业务类型列表
 */
export const getBusinessJsonList = () => request().get('business/jsonList')









